/**
 * @description selector to get all overtakes.
 * @param {*} state
 * @return {*}
 */
export const getOvertakesSelector: (state: any) => Overtake[] =
    (state) => ((state.Overtakes && state.Overtakes.data) ?
      state.Overtakes.data : []);
